<template>
	<div class="">
		<div v-if="firstTrackQue && firstTrack" class="subtitle-display scroll-y pdt-32" style="padding: unset">
			<div v-for="cue in firstTrackQue.cues" :key="cue.startTime"
				:class="{ active: cue.startTime === firstTrackStartTime }" class="d-flex mgb-20">
				<div :class="lightModeActive ? '' : 'bg-whiteBorder'"
					class="mgt-4 min-w-50 h-20 b-radius4 d-flex justify-content-center align-center t-body6 font-rn t-color-whiteHigh2 d-flex align-items-center">
					{{ handleStartTime(cue.startTime) }}
				</div>
				<div v-if="elementVideo.currentTime >= cue.startTime &&
					elementVideo.currentTime <= cue.endTime &&
					cue.startTime === firstTrackStartTime
					" class="t-body1 t-line-h-28 active-text t-color-white mgl-28 myTrackColor">
					<span> {{ cue.text }} ​​​</span>
				</div>
				<div v-else class="t-body1 t-line-h-28 t-color-whiteHigh2 mgl-28 myTrackColor">
					<span> {{ cue.text }} ​​​</span>
				</div>
				<!-- <div class="min-w-100 mgl-100"></div> -->
			</div>
			<button id="btnTextSize" class="mdc-button" tabindex="0" v-bind:class="{ active: isLargeText }"
				@click="onLargeText()" @keypress="onLargeText()"></button>
		</div>
	</div>
</template>

<script>
// Show subtile on second tab(script) of video
import { MDCRipple } from "@material/ripple";

export default {
	props: [
		"firstTrack",
		"secondTrack",
		"lessonName",
		"firstTrackStartTime",
		"lightModeActive",
		"elementVideo",
		"setedFirstSubtitle",
	],

	data() {
		return {
			isLargeText: false,
			trackFirstSubtitle: null,
			firstTrackQue: null,
			lang: this.setedFirstSubtitle,
		};
	},

	mounted() {
		this.setTrack(this.firstTrackStartTime);
		this.setMaterialUi();
	},

	watch: {
		firstTrackStartTime(activeStartTime) {
			this.setTrack(activeStartTime);
			this.setAnswer(this.setedFirstSubtitle);
		},

		firstTrackQue: function () {
			this.setAnswer(this.setedFirstSubtitle);
		},
	},

	methods: {
		setAnswer(data) {
			this.firstTrackQue =
				this.elementVideo.textTracks[
				_.findIndex(this.elementVideo.textTracks, (track) => {
					return track.language === data;
				})
				];
		},

		setMaterialUi() {
			const buttonRipple = [].map.call(
				document.querySelectorAll(".mdc-button"),
				function (el) {
					let button = new MDCRipple.attachTo(el);
					return button;
				}
			);
		},

		// 자막 트렉 설정(Subtitle Track Settings)
		setTrack(activeStartTime) {
			this.setAnswer();
			let element = this.$refs[`cue_${activeStartTime}`];
			this.activeStartTime = activeStartTime;

			if (element) {
				this.moveScroll(element[0]);
			}
		},

		// 닫기(close)
		onClose: function () {
			this.$emit("subtitles-toggle");
		},

		// 자막 폰트 사이즈 설정(Subtitle font size adjustment)
		onLargeText: function () {
			this.isLargeText = !this.isLargeText;
		},

		// 자막 스크롤 이동(Automatic scrolling)
		moveScroll(element) {
			let options = {
				container: this.$refs.subtitles,
				easing: "ease-in",
			};
			this.$scrollTo(element, 500, options);
		},

		onToggleSubtitleSettings() {
			this.$emit("onToggleSubtitleSettings");
		},

		handleStartTime(time) {
			const min = String(Math.floor((time / 60) % 60)).padStart(2, "0");
			const sec = String(Math.floor(time % 60)).padStart(2, "0");
			return `${min}:${sec}`;
		},
	},
};
</script>
<style scoped>
.scrollable-content-subtitle {
	max-height: 35px;
}

.myTrackColor.active-text span {
	background-color: var(--LinkBlue) !important;
}

#studyContainer #container #subtitlesContainer>div {
	padding-left: 49px;
	padding-right: 19px;
}

html[dir="rtl"] #studyContainer #container #subtitlesContainer>div {
	padding-right: 49px;
	padding-left: 19px;
}

#studyContainer #container #subtitlesContainer ul {
	width: auto;
}

#btnTextSize {
	min-width: 28px !important;
}

#subtitles ul:before {
	content: "";
	width: 100%;
	height: 77px;
	background: red;
	position: absolute;
	top: 56px;
	left: 0;
	background: linear-gradient(to bottom,
			rgba(27, 35, 43.8) 70%,
			rgba(229, 229, 229, 0) 100%);
}

html[dir="rtl"] #subtitles ul:before {
	right: 0;
}

#subtitles ul:after {
	content: "";
	width: 100%;
	height: 77px;
	background: red;
	position: absolute;
	bottom: -44px;
	left: 0;
	background: linear-gradient(to bottom,
			rgba(229, 229, 229, 0) 0%,
			rgba(27, 35, 43, 1) 18%,
			rgba(27, 35, 43, 1) 100%);
}

html[dir="rtl"] #subtitles ul:after {
	right: 0;
}

#controls {
	margin-top: 0;
}
</style>